import { Outlet, Navigate, useNavigate, useLocation } from "react-router-dom";
import { USER_ROLE } from "../../../core/Constant";
import { useEffect, useRef, useState } from "react";
import { Actions } from "../../../core/modules/Actions";
import { connect, useDispatch } from "react-redux";
import { NotificationAlert } from "../../molecule";
import { setTopLevelNavigator } from "../../../core/services/NavigationServicd";
import TermsAndConditionsDialog from "../../molecule/Dialog/TermsAndConditionsDialog";
import _ from "lodash";

const StudentRoutes = ({ getcourseProgress, courseprogress, getNotifications, notifications, currentUser, authCurrentUser, getUserData, acceptTermsAndConditions }) => {
  const [initialCourse, setInitialCourse] = useState([]);
  const [unreadNotify, setUnread] = useState([]);
  const [read, setRead] = useState(true);
  const [showTermsDialog, setShowTermsDialog] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(() => {
    return localStorage.getItem('termsAccepted') === 'true';
  });
  const navigate = useNavigate();
  const location = useLocation();
  const intervalRef = useRef(null);
  const hasCalledGetUserData = useRef(false);

  const dispatch = useDispatch();
  const onNavigate = (path, obj = {}) => {
      if (path) {
          navigate(path, obj);
      }
  }

  useEffect(() => {
      intervalRef.current = onNavigate;
      setTopLevelNavigator(intervalRef);
  }, [navigate]);


  useEffect(() => {
    getcourseProgress();
  }, [location, getcourseProgress]);


  useEffect(() => {
    const userId = parseInt(localStorage.getItem("userId"));
    if (userId) {
      getNotifications(userId);
    }
  }, [location, getNotifications]); 


  useEffect(() => {
    const unread = notifications.filter((notification) => notification.is_read === 0);
    setUnread(unread);
  }, [notifications]);


  useEffect(() => {
    const firstCourse = courseprogress[0] || {};
    setInitialCourse(firstCourse);
    if (firstCourse?.course_id) {
      localStorage.setItem("firstcourse", firstCourse.course_id);
    }
  }, [courseprogress]);

 
  useEffect(() => {
    // Check localStorage first - if terms are already accepted locally, don't override
    const localTermsAccepted = localStorage.getItem('termsAccepted') === 'true';
    if (localTermsAccepted) {
      setTermsAccepted(true);
      setShowTermsDialog(false);
      return; // Exit early if terms are already accepted locally
    }
    
    if (authCurrentUser && Object.keys(authCurrentUser).length > 0) {
      const loginTermsAccepted = _.get(authCurrentUser, 'terms_accepted', false);
      
      if (loginTermsAccepted) {
        setTermsAccepted(true);
        setShowTermsDialog(false);
        if (!hasCalledGetUserData.current) {
          console.log('Calling getUserData from login response (terms_accepted: true)');
          getUserData();
          hasCalledGetUserData.current = true;
        }
      } else {
        setShowTermsDialog(true);
        setTermsAccepted(false);
      }
    } 
    else if (currentUser && Object.keys(currentUser).length > 0) {
      const backendTermsAccepted = _.get(currentUser, 'terms_accepted', false) || 
                                    _.get(currentUser, 'termsAccepted', false);
      
      if (backendTermsAccepted) {
        setTermsAccepted(true);
        setShowTermsDialog(false);
      } else {
        setShowTermsDialog(true);
        setTermsAccepted(false);
      }
    } 
    else {
      setShowTermsDialog(true);
      setTermsAccepted(false);
    }
  }, [authCurrentUser, currentUser, getUserData]);

  useEffect(() => {
    if (termsAccepted) {
      if (!hasCalledGetUserData.current) {
        console.log('Calling getUserData because terms are accepted, termsAccepted:', termsAccepted);
        getUserData();
        hasCalledGetUserData.current = true;
      }
    } else {
      hasCalledGetUserData.current = false;
    }
  }, [termsAccepted, getUserData]);

  const handleAcceptTerms = async () => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      dispatch(acceptTermsAndConditions({ user_id: userId }));
      setTermsAccepted(true);
      setShowTermsDialog(false);
      localStorage.setItem('termsAccepted', 'true');
      localStorage.setItem('termsAcceptedDate', new Date().toISOString());
    } else {
      setTermsAccepted(true);
      setShowTermsDialog(false);
      localStorage.setItem('termsAccepted', 'true');
    }
  };

  const handleClose = () => {
    setRead(false);
    navigate("/StudentNotification");
  };

  const user = parseInt(localStorage.getItem("userType"));
  
  return (
    <>
      <div style={{ display: termsAccepted ? 'block' : 'none', pointerEvents: termsAccepted ? 'auto' : 'none' }}>
        {user === USER_ROLE.student ? <Outlet /> : <Navigate to="*" />}
        {unreadNotify.length > 0 && termsAccepted && (
          <NotificationAlert
            handleClose={handleClose}
            isread={read}
            data={{
              title: "Notification",
              message: unreadNotify.length > 1 ? `You have ${unreadNotify.length} Unread Notifications` : "You have Unread Notification",
            }}
          />
        )}
      </div>
      
      {/* Show terms dialog when terms not accepted */}
      {!termsAccepted && (
        <TermsAndConditionsDialog
          open={showTermsDialog}
          onAccept={handleAcceptTerms}
          onClose={() => {}} // Prevent closing without acceptance
        />
      )}
    </>
  );
};

export default connect(
  (state) => ({
    courseprogress: state.home.get("courseprogress"),
    notifications: state.notification.get("notifications"),
    currentUser: state.profile.get("currentUser"),
    authCurrentUser: state.auth.get("currentUser"), // Login response data
  }),
  {
    getcourseProgress: Actions.home.getcourseProgress,
    getNotifications: Actions.notification.getNotifications,
    getUserData: Actions.profile.getUserData,
    acceptTermsAndConditions: Actions.profile.acceptTermsAndConditions,
  }
)(StudentRoutes);
